import { ReactNode, useContext, useState } from "react";
import React from "react";
import { InputOnChangeData, Table } from "semantic-ui-react";
import { numberValidatorN, StatePackage } from "../State";
import { Action, arrayGenerator, store } from "../store";
import QuestionAnswer from "../answers/QuestionAnswer";

// tslint:disable-next-line: interface-name
interface Props {
    children: ReactNode;
    questionContent: string;
    source: any[];
    generator: arrayGenerator;
    action: Action;
    inverted: boolean;
    fixed?: boolean;
    min?: number;
    max?: number;
    index: number;
  }

// tslint:disable-next-line: interface-name
interface EnumeratedTableState {
    numberOfRows: number;
}

// tslint:disable-next-line: max-line-length
function handleNumbersChange(index: number, e: InputOnChangeData, dispatch: React.Dispatch<Action>, action: Action, source: any[], generator: arrayGenerator, s2: StatePackage<EnumeratedTableState>, max: number): void {
    const value = (parseInt(e.value, 10) || 0);
    s2.setState({ ...s2.state, numberOfRows: value });

    const newItems = (max == 0 || value < max) ? value - source.length : max - source.length;

    // tslint:disable-next-line: max-line-length
    dispatch({ ...action, value: (newItems > 0) ? source.concat(Array.from({ length: newItems }, generator)) : source.filter((x, i) => i < value), index: index });
}

const EnumeratedTable: React.FunctionComponent<Props> = (props: Props) => {
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const [state, setState] = useState<EnumeratedTableState>({ numberOfRows: props.source.length });

    return (
        <div>
            {
                !props.fixed &&
                <QuestionAnswer index={props.index}
                    propsBase={{
                        answerContent: "", answerType: "number", answerValidator: numberValidatorN(),
                        isRequired: true, questionContent: props.questionContent, min: props.min, max: props.max,
                        answerValue: props.source.length ? `${props.source.length}` : "", isAnswerValid: true,
                        isAnswered: state.numberOfRows > 0, showError: false, propName: "N/A"
                    }}
                    // tslint:disable-next-line: max-line-length
                    onChange={(e, i, d) => handleNumbersChange(props.index, d as InputOnChangeData, dispatch,
                        props.action, props.source, props.generator, { setState, state }, props.max || 0)}
                />
            }
            {
                props.source.length > 0 &&
                <Table size={"small"} inverted={props.inverted} stackable error style={props.fixed && { marginTop: "20px"  }}>
                    <Table.Body>
                        {props.children}
                    </Table.Body>
                </Table>
            }
      </div>
    );
  };

export default EnumeratedTable;
